import isEmpty from 'lodash-es/isEmpty';
import L from 'leaflet';

function formatTrackingPoints(points) {
  let lines = [];
  let line = [];

  points.forEach((point, index) => {
    const currentPoint = point.position;
    const nextPoint = points[index+1] ? points[index+1].position : undefined;
    line.push(currentPoint);

    if(pointsCrossAntimeridian(currentPoint, nextPoint)) {
      lines.push(line);
      line = [];
    }
  });

  if(line.length) {
    lines.push(line);
  }

  return lines;
}


function pointsCrossAntimeridian(point1, point2) {
  if(!point1 || ! point2) {
    return false;
  }

  let long1 = point1[1];
  let long2 = point2[1];

  if(Math.abs(long1) > 90 && Math.abs(long2) > 90 && Math.sign(long1) !== Math.sign(long2)) {
    return true;
  }
  return false;
}

function leafletBoundsToApi(bounds) {
  return {
    lowerLeft: [bounds._southWest.lng, bounds._southWest.lat],
    upperRight: [bounds._northEast.lng, bounds._northEast.lat],
  };
}

function apiCoordsToLatLng(apiCoordinates) {
  return L.latLng(apiCoordinates[1], apiCoordinates[0]);
}


function getCoordinateBounds(coordinates) {
  const latitudes = coordinates.map(item => item.lat);
  const longitudes = coordinates.map(item => item.lng);

  if(isEmpty(latitudes) || isEmpty(longitudes)) {
    return null;
  }

  // mapBounds goes to the <base-map> props and the watcher will update leaflet bounds
  return [
    L.latLng(Math.min(...latitudes), Math.min(...longitudes)),
    L.latLng(Math.max(...latitudes), Math.max(...longitudes)),
  ];
}


export {
  pointsCrossAntimeridian,
  formatTrackingPoints,
  leafletBoundsToApi,
  apiCoordsToLatLng,
  getCoordinateBounds,
}
